<template>
    <div class="flex items-center text-gray-800 rounded-md h-72 mt-24 mx-4 pt-6">
        <div>
            <span class="uppercase">{{this.patient.name[0].family}}</span>, {{this.patient.name[0].given}}
        </div>
        <div class="ml-4">D.O.B: {{this.patient.birthDate}}</div>
        <div class="ml-4">{{this.patient.identifier[0].assigner}}: {{this.patient.identifier[0].value}}</div>
    </div>
</template>

<script>
export default {
  props: ['patient']
}
</script>
